import { render, staticRenderFns } from "./Deletion.vue?vue&type=template&id=4724e094"
import script from "./Deletion.vue?vue&type=script&lang=js"
export * from "./Deletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports